export const config = {
  title: "South Park Striping | Pavement Marking in Jefferson Area",
  meta: {
    description:
      "South Park Striping provides professional pavement marking and striping services for commercial and residential clients in the Jefferson Area.",
    keywords: [
      "Jefferson Area striping",
      "South Park Striping",
      "pavement marking",
      "line painting",
      "asphalt maintenance"
    ],
    author: "South Park Striping",
    canonicalUrl: "https://southparkstripingllc.com/",
  },
  sections: {
    header: {
      businessName: "South Park Striping",
    },
    sectionB: {
      heroTitle: "South Park Striping",
      heroSubtitle: "Reliable Pavement Marking & Striping in Jefferson Area",
      learnAboutText: "Get a Free Quote",
      phoneNumber: "9705750199",
      phoneLabel: "(970) 575-0199",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1220432012/photo/close-up-of-double-yellow-lines-at-the-curb-of-a-residential-street.jpg?s=612x612&w=0&k=20&c=9Zy75oxl-j8nkIzRD9Cw7slPhE1JyPrvKPrBWaKlXRg=",
      cardData: [
        {
          title: "Commercial Striping",
          description: "High-quality line painting and layout services for parking lots and roads.",
        },
        {
          title: "Residential Services",
          description: "Driveway striping, small-lot layouts, and private property marking.",
        },
        {
          title: "Thermoplastic Application",
          description: "Durable pavement markings for high-traffic and long-term use.",
        },
      ],
      description:
        "Proudly serving Jefferson and surrounding areas, South Park Striping offers expert striping and pavement marking services with a commitment to precision, safety, and long-term durability.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "We provide complete pavement marking solutions tailored for both residential and commercial clients.",
      cards: [
        {
          title: "Parking Lot Striping",
          description: "Clean and accurate layout for new and existing lots.",
          imageSrc: "https://media.istockphoto.com/id/1127553343/photo/striping-machine-on-the-parking-lot.jpg?s=612x612&w=0&k=20&c=MQ2k-W86LJ1QXKMmQ5N_Q64dndwFypSvFaQ5FlXi9MA=",
          imageAlt: "Parking Lot Striping",
        },
        {
          title: "Thermoplastic Markings",
          description: "Highly durable markings ideal for long-term use.",
          imageSrc: "https://media.istockphoto.com/id/512335214/photo/black-asphalt-pavement-painted-with-yellow-stripes.jpg?s=612x612&w=0&k=20&c=0x18zAtaoWJveLMtmazpySUmpLizc3i6_bcddBzzwGo=",
          imageAlt: "Thermoplastic Striping",
        },
        {
          title: "ADA Compliance Striping",
          description: "Ensure accessibility and compliance with ADA regulations.",
          imageSrc: "https://media.istockphoto.com/id/146811553/photo/blue-and-yellow-empty-handicap-parking-space.jpg?s=612x612&w=0&k=20&c=sG97u5gfpSd4bmLVKZXvEv7dN-zN4_5jt5Fl1mLIdX4=",
          imageAlt: "ADA Compliance",
        },
      ],
      otherServicesTitle: "Why Choose Us",
      otherServicesList: [
        "High-Quality Striping Equipment",
        "Experienced Technicians",
        "Flexible Scheduling",
        "Competitive Pricing",
        "Locally Owned & Operated",
      ],
    },
    sectionD: {
      aboutTitle: "About South Park Striping",
      aboutImage: {
        src: "https://media.istockphoto.com/id/1177557329/photo/empty-parking-lot-in-city-street.jpg?s=612x612&w=0&k=20&c=HVnzC2iMtMxTQ3XVrtOrnXZv-XYL1qzrP-_SPd4Tmqw=",
        alt: "South Park Striping Team",
      },
      aboutText: [
        "South Park Striping is a reliable pavement marking provider serving the Jefferson Area.",
        "We specialize in professional striping for roads, parking lots, and more — with a focus on safety, clarity, and durability.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "South Park Striping Logo",
      businessName: "South Park Striping",
      contact: {
        phone: "9705750199",
        phoneLabel: "(970) 575-0199",
        email: "southparkstriping@gmail.com",
        website: "https://southparkstripingllc.com/",
        address: "Serving Jefferson Area",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "Serving Jefferson Area",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3105!2d-106.0!3d39.3!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2sJefferson%20County!5e0!3m2!1sen!2sus!4v1710000000000",
    },
  },
};

export default config;
